import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// roles: array of allowed roles. If omitted, any authenticated user is allowed.
export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    // Redirect to their allowed landing page
    const fallback = user.role === "voucher_staff" ? "/voucher" : "/";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
